import { render, staticRenderFns } from "./FormRenda.vue?vue&type=template&id=073d0db0&"
import script from "./FormRenda.vue?vue&type=script&lang=js&"
export * from "./FormRenda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports